<script>
  import { onMount } from 'svelte'
  import Button from '../../components/Button.svelte'
  import Modal from '../../components/Modal.svelte'
  import ModalContent from './ModalContent.svelte'
  import Summary from './Summary.svelte'
  import configMod from '../../config'
  import { isMobileBrowser } from '../../utils'

  const config = configMod()
  const CDN_URL = config.serverName

  const addIcon = `${CDN_URL}/icons/icon-add.svg`
  const questionIcon = `${CDN_URL}/icons/icon-question-mark.svg`

  export let summary
  export let settings
  export let summaryType

  let reviewButtonText
  let questionButtonText
  let buttonColor
  let textColor
  let showQna
  let showReviewForm

  onMount(() => {
    reviewButtonText = settings.translations.neptune.write_review_text
    questionButtonText = settings.translations.neptune.write_qna_text
    buttonColor = settings.widget_settings.general_settings.primary_color
    textColor = settings.widget_settings.general_settings.button_text_color
    showQna =
      settings.widget_settings.neptune.show_questions_and_answers &&
      ((isMobileBrowser() &&
        settings.widget_settings.qna_form.mobile_visibility) ||
        (!isMobileBrowser() &&
          settings.widget_settings.qna_form.desktop_visibility))
    showReviewForm =
      (isMobileBrowser() &&
        settings.widget_settings.review_form.mobile_visibility) ||
      (!isMobileBrowser() &&
        settings.widget_settings.review_form.desktop_visibility)
  })
</script>

<style>
  #middle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    position: static;
  }

  #actions {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  }

  :global(._3BG_6,)
  :global(._3v3C5) {
    margin-top: 5px;
  }
</style>

<section id="middle">
  <div id="summary">
    {#if summary}
      <Summary {summaryType} {summary} {settings} />
    {/if}
  </div>
  <div id="actions">
    {#if showReviewForm}
      <div class="_3BG_6">
        <Modal>
          <ModalContent name="ReviewForm" {settings}>
            <Button
              hasIcon={true}
              icon={addIcon}
              name="add-review-button"
              btnTheme="small"
              backgroundColor={buttonColor}
              {textColor}
              buttonText={reviewButtonText}
              textTransform="capitalize" />
          </ModalContent>
        </Modal>
      </div>
    {/if}
    {#if showQna}
      <div class="_3v3C5">
        <Modal>
          <ModalContent name="QuestionForm" {settings}>
            <Button
              hasIcon={true}
              icon={questionIcon}
              name="add-question-button"
              btnTheme="small"
              backgroundColor={buttonColor}
              {textColor}
              buttonText={questionButtonText}
              textTransform="capitalize" />
          </ModalContent>
        </Modal>
      </div>
    {/if}
  </div>
</section>
